import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import {BASE_URL} from 'js/constants';
import {AppStore} from 'js/stores'; // singleton stores
import {
  Home,
  Phaseresult,
  Registration,
  Result,
  Notfound,
} from 'js/screens';

/**
 * Router
 */
export default class Router extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <Switch>
        <Route exact path={`${BASE_URL}/`} component={Home} />
        {AppStore.step.aggregate && (
          <Route path={`${BASE_URL}/result`} component={Result} />
        )}
        {AppStore.step.aggregate && (
          <Route path={`${BASE_URL}/registration`} component={Registration} />
        )}
        {AppStore.step.regist && (
          <Route path={`${BASE_URL}/phaseresult`} component={Phaseresult} />
        )}
        <Route component={Notfound} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/router.js